import { isAxiosError } from 'axios';
import { axiosAuth } from '@/axios';
import { Endpoints } from '@/enums';

export interface IngresarFechaAprobacionRequest {
  userName: string;
  password: string;
}

export const ingresarFechaAprobacion = async (
  data: IngresarFechaAprobacionRequest
) => {
  try {
    const res = await axiosAuth.post(Endpoints.IngresarFechaAprobacion, data);
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
